import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import boxStyles from '../../../styles/boxStyles';
import AddIcon from '@mui/icons-material/Add';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

const ButtonUser = ({
  dataRegion,
  dataLokasi,
  dataTahun,
  dataInsiden,
  setRegionId,
  setHipo,
  setLocationId,
  setYear,
  setTipeKejadianId,
  setFilterSearch,
  setFilterNoInvestigasi,
}) => {
  const history = useNavigate();

  // const [region, setRegion] = useState("");
  // const [lokasi, setLokasi] = useState("");
  // const [tahun, setTahun] = useState();
  // const [type, setType] = useState();

  const handleRegion = (event) => {
    setRegionId(event.target.value);
  };
  const handleHipo = (event) => {
    setHipo(event.target.value);
  };
  const handleLokasi = (event, value) => {
    if (!event || !value) {
      setLocationId(null);
    } else {
      setLocationId(value.id);
    }
  };
  const handleTahun = (event) => {
    setYear(event.target.value);
  };
  const handleType = (event) => {
    setTipeKejadianId(event.target.value);
  };

  const handleReset = () => {
    setRegionId(0);
    setLocationId(0);
    setYear(0);
    setTipeKejadianId(0);
  };

  const AddNew = () => {
    history('/hsse/incident/createlkp');
  };

  return (
    <Box component="div" sx={{ px: 1, pt: 1 }}>
      <Stack spacing={1} direction="row">
        <FormControl variant="filled" fullWidth>
          <InputLabel id="demo-simple-select-label">Region</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            // value={region}
            label="Region"
            onChange={handleRegion}
          >
            {dataRegion.map((data) => (
              <MenuItem id={data.id} key={data.id} value={data.id}>
                {data.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl variant="filled" fullWidth>
          <InputLabel id="demo-simple-select-label"> Category HIPO</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            // value={region}
            label="Region"
            onChange={handleHipo}
          >
            {[
              { id: 0, name: 'All', value: null },
              { id: 1, name: 'Hipo', value: true },
              { id: 2, name: 'Non-Hipo', value: false },
            ].map((data) => (
              <MenuItem id={data.id} key={data.id} value={data.value}>
                {data.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl variant="filled" fullWidth>
          <TextField
            onChange={(e) => setFilterSearch(e.target.value)}
            label="Search"
            variant="filled"
          />
          {/* <Autocomplete
            name="idLokasi"
            onChange={handleLokasi}
            required
            disabled={dataLokasi.length === 0}
            getOptionLabel={(option) => option.name}
            options={dataLokasi}
            renderInput={(params) => (
              <TextField {...params} label="Lokasi" variant="filled" />
            )}
            getOptionSelected={(option, value) => option.name === value.name}
          /> */}
        </FormControl>
        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
          <InputLabel id="lblSelectTahun">Tahun</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="SelectTahun"
            // value={tahun}
            label="Tahun"
            onChange={handleTahun}
          >
            {dataTahun.map((data) => (
              <MenuItem id={data.id} key={data.id} value={data.id}>
                {data.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl variant="filled" fullWidth>
          <InputLabel id="demo-simple-select-label">Type Incident</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            // value={type}
            label="Lokasi"
            onChange={handleType}
          >
            {dataInsiden.map((data) => (
              <MenuItem id={data.id} key={data.id} value={data.id}>
                {data.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl variant="filled" fullWidth>
          <TextField
            onChange={(e) => setFilterNoInvestigasi(e.target.value)}
            label="No Investigasi"
            variant="filled"
          />
          {/* <Autocomplete
            name="idLokasi"
            onChange={handleLokasi}
            required
            disabled={dataLokasi.length === 0}
            getOptionLabel={(option) => option.name}
            options={dataLokasi}
            renderInput={(params) => (
              <TextField {...params} label="Lokasi" variant="filled" />
            )}
            getOptionSelected={(option, value) => option.name === value.name}
          /> */}
        </FormControl>
        <Button
          variant="contained"
          style={{
            borderRadius: 3,
            backgroundColor: 'grey',
            // padding: "18px 36px",
            // fontSize: "18px"
          }}
          onClick={handleReset}
        >
          Reset
        </Button>
        {/* <Button
          variant="contained"
          style={{
            borderRadius: 3,
            backgroundColor: "grey",
            // padding: "18px 36px",
            // fontSize: "18px"
          }}
        >
          Unduh
        </Button> */}
      </Stack>
    </Box>
  );
};

export default ButtonUser;
